//StyledPendenciaComponents

// StyledPendenciaComponents.js
import styled from "styled-components";

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
`;

export const CustomTableHeader = styled.th`
  padding: 12px;
  text-align: ${({ align }) => align || "left"};
  background-color: #f4f4f4;
  border-bottom: 2px solid #ddd;
  font-family: "Roboto", sans-serif;
  font-weight: 600;
  font-size: 12px;
  color: #333;
`;

export const CustomTableCell = styled.td`
  padding: 8px;
  width: ${({ width }) => (width ? `${width}px` : "auto")};
  border-bottom: 1px solid #eee;
  font-family: "Roboto", sans-serif;
  font-weight: 500;
  font-size: 12px;
  color: #555;
  text-align: ${({ align }) => align || "left"};
`;

export const PendenciaInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const PendenciaInfoRow = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 4px;
`;

export const PendenciaValue = styled.span`
  font-size: 12px;
  color: #555;
`;
